import { formatRequestsListTable } from '../resources/js/helpers/tableUtils'
import { put, getAll, clear } from './utils/transactionHelpers'

function sanitizePMData(data) {
    return data.map(item => {
        const sanitizedItem = { ...item }
        const cleanObject = obj => {
            Object.keys(obj).forEach(key => {
                const value = obj[key]
                if (typeof value === 'object' && value !== null) {
                    if (Array.isArray(value)) {
                        obj[key] = value.map(item => cleanObject(item))
                    } else if (value instanceof Date) {
                        obj[key] = value.toISOString()
                    } else {
                        obj[key] = cleanObject({ ...value })
                    }
                } else if (
                    typeof value === 'function' ||
                    typeof value === 'symbol'
                ) {
                    delete obj[key]
                }
            })
            return obj
        }

        return cleanObject(sanitizedItem)
    })
}

export async function savePMWorkOrders(workOrders, type) {
    try {
        const sanitizedWorkOrders = sanitizePMData(workOrders).map(order => ({
            ...order,
            type,
        }))

        // Use Promise.all for bulk operations
        const putPromises = sanitizedWorkOrders.map(order =>
            put('pmWorkOrders', order),
        )
        await Promise.all(putPromises)
    } catch (error) {
        console.error('Error saving PM Work Orders:', error)
        throw error
    }
}

export async function getPMWorkOrdersByType(type) {
    try {
        // Get all work orders and filter by type
        const allWorkOrders = await getAll('pmWorkOrders')
        return allWorkOrders
            .filter(order => order.type === type)
            .sort((a, b) => a.orderIndex - b.orderIndex)
    } catch (error) {
        console.error('Error retrieving PM Work Orders by type:', error)
        throw error
    }
}

export async function saveAllPMWorkOrdersBatch(workOrdersByType) {
    try {
        const allWorkOrders = Object.entries(workOrdersByType).flatMap(
            ([type, workOrders]) => {
                return sanitizePMData(workOrders).map((request, index) => ({
                    ...request,
                    type,
                    orderIndex: index,
                }))
            },
        )

        // Use Promise.all for bulk operations
        const putPromises = allWorkOrders.map(order =>
            put('pmWorkOrders', order),
        )
        await Promise.all(putPromises)
    } catch (error) {
        console.error('Error saving all PM Work Orders:', error)
        throw error
    }
}

export const saveAllPMWorkOrders = async response => {
    try {
        const { openPMRequests = [], closedPMRequests = [] } = response.data

        const workOrdersByType = {
            openPM: formatRequestsListTable(openPMRequests, 'openPM'),
            closedPM: formatRequestsListTable(closedPMRequests, 'closedPM'),
        }

        await saveAllPMWorkOrdersBatch(workOrdersByType)
    } catch (error) {
        console.error('Error saving all PM Work Orders:', error)
        throw error
    }
}

export const deleteAllPMWorkOrders = async () => {
    try {
        await clear('pmWorkOrders')
        console.log('All PM Work Orders deleted successfully')
    } catch (error) {
        console.error('Error deleting PM Work Orders:', error)
        throw error
    }
}
